var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          attrs: { stretch: true, "tab-position": _vm.tabPosition },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Προσωπικά Στοιχεία", name: "first" } },
            [
              _c("personal-details", {
                attrs: {
                  personalDetails: _vm.workingApplication.personalDetails
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isReappraisal
            ? _c(
                "el-tab-pane",
                { attrs: { label: "Τίτλος Σπουδών", name: "second" } },
                [
                  _c("titles", {
                    attrs: { application: _vm.workingApplication }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isReappraisal &&
          _vm.workingApplication.degreeType === "bachelor" &&
          _vm.workingApplication.consideration === true
            ? _c(
                "el-tab-pane",
                { attrs: { label: "Συνυποβολή Τίτλου", name: "third" } },
                [
                  _c("title-consideration", {
                    attrs: { application: _vm.workingApplication }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Ιστορικό", name: "fourth" } },
            [
              _c("history-line", { attrs: { applicationHistory: _vm.history } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Επισυναπτόμενα", name: "fifth" } },
            [
              _c("attached-documents", {
                attrs: {
                  attachedDocumentsTable: _vm.attachedDocumentsTable,
                  neededDocuments: _vm.workingApplication.neededDocuments,
                  appId: _vm.workingApplication.id
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isReappraisal
            ? _c(
                "el-tab-pane",
                { attrs: { label: "Σχετική αίτηση", name: "seventh" } },
                [
                  _c("relevant-app", {
                    attrs: {
                      relevantApp: _vm.workingApplication.relevantApplication
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Αποτέλεσμα Επεξεργασίας", name: "eighth" } },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingWorkingApplication,
                      expression: "loadingWorkingApplication"
                    }
                  ],
                  ref: "ref1",
                  attrs: {
                    inline: false,
                    model: _vm.workingApplication,
                    "label-width": "170px",
                    "label-position": "right"
                  }
                },
                [
                  !_vm.isReappraisal
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Ειδικός Εισηγητής:" } },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.specialProponentProposal)
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReappraisal
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Σημείωση Αντιπροέδρου:" } },
                        [_c("span", [_vm._v(_vm._s(_vm.viceNote))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.fromConsultant ? _c("hr") : _vm._e(),
                  _vm._v(" "),
                  _vm.fromConsultant
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Ακαδημαικός Σύμβουλος:" } },
                        [_vm._v(_vm._s(_vm.consultantProposal))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Εκτελεστική επιτροπή:" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.membersDecisions }
                        },
                        [
                          _c(
                            "el-table-column",
                            { attrs: { label: "Αποφάσεις Μελών Επιτροπής" } },
                            [
                              _c("el-table-column", {
                                attrs: { label: "Όνομα", width: "150" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.firstname))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "Επώνυμο", width: "150" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.surname))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _vm.isReappraisal
                                ? _c("el-table-column", {
                                    attrs: {
                                      label: "Πλήρης αποδοχή",
                                      align: "center",
                                      width: "150"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            scope.row
                                              .fullyAgreeWithReappraisal ===
                                            true
                                              ? _c(
                                                  "span",
                                                  { staticClass: "agree-btn" },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-check"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row
                                              .fullyAgreeWithReappraisal ===
                                            false
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "disagree-btn"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-close"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row
                                              .fullyAgreeWithReappraisal ===
                                            null
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "pending-btn"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-minus"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isReappraisal
                                ? _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        label: "Αποδοχή πρότασης",
                                        align: "center"
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Εισηγητή",
                                          width: "90",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                scope.row.agreeWithProponent ===
                                                true
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "agree-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-check"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.agreeWithProponent ===
                                                false
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "disagree-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-close"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                scope.row.agreeWithProponent ===
                                                null
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pending-btn"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-minus"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _vm._v(" "),
                                      _vm.fromConsultant
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "Ακαδημαικού Συμβούλου",
                                              width: "110",
                                              align: "center"
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    scope.row.agreeWithAC ===
                                                    true
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "agree-btn"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-check"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.agreeWithAC ===
                                                    false
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "disagree-btn"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-close"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    scope.row.agreeWithAC ===
                                                    null
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pending-btn"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-minus"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ])
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "Εισήγηση" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.proposal))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Υποβολή",
                                  width: "85",
                                  align: "center"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.finalize === true
                                          ? _c(
                                              "span",
                                              { staticClass: "done-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.finalize === false
                                          ? _c(
                                              "span",
                                              { staticClass: "pending-btn" },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-edit"
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.proposalFound && _vm.isReappraisal
                    ? _c(
                        "el-form-item",
                        [
                          _vm._v(
                            "Εισήγηση Εκτελεστικής Επιτροπής\r\n          "
                          ),
                          _c("el-alert", {
                            attrs: {
                              type: "warning",
                              title:
                                "Υπάρχει εισήγηση της Εκτελεστικής Επιτροπής (στην καρτέλα Επισυναπτόμενα)",
                              "show-icon": ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReappraisal &&
                  (!_vm.proposalFound ||
                    this.workingApplication.attachedDocuments.slice(-1)[0]
                      .uploadedBy === this.currentUser.id)
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Ανεβάστε εισήγηση" } },
                        [
                          _c(
                            "el-upload",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: this.uploading,
                                  expression: "this.uploading"
                                }
                              ],
                              ref: "uploadReappraisalProposal",
                              staticClass: "upload-demo",
                              attrs: {
                                accept: ".pdf, .doc",
                                "file-list": _vm.boardAttachments,
                                "http-request": _vm.addAttachment,
                                "on-remove": _vm.handleRemove,
                                "on-preview": _vm.viewPdf,
                                "before-remove": _vm.handleBeforeRemove,
                                action: "",
                                limit: 1,
                                "auto-upload": true,
                                "show-file-list": true
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    size: "small",
                                    type: "primary"
                                  },
                                  slot: "trigger"
                                },
                                [_vm._v("Ανέβασμα")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [
                                  _vm._v(
                                    "** Μ Ο Ν Ο για να ανεβάσετε εισήγηση της Ειδ. Επιτρ. Επανεξέτασης ( αρχείο pdf μεγέθους μέχρι 12MB)"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReappraisal
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Πλήρης αποδοχή" } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "Πλήρης αποδοχή ή όχι του αιτήματος επανεξέτασης",
                                placement: "top-start"
                              }
                            },
                            [
                              !_vm.myJudgment.finalize
                                ? _c("el-switch", {
                                    attrs: {
                                      "active-text": "Ναι",
                                      "inactive-text": "Όχι"
                                    },
                                    model: {
                                      value:
                                        _vm.myJudgment
                                          .fullyAgreeWithReappraisal,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.myJudgment,
                                          "fullyAgreeWithReappraisal",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "myJudgment.fullyAgreeWithReappraisal"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.myJudgment.finalize &&
                              _vm.myJudgment.fullyAgreeWithReappraisal
                                ? _c("span", { staticClass: "agree-btn" }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.myJudgment.finalize &&
                              !_vm.myJudgment.fullyAgreeWithReappraisal
                                ? _c("span", { staticClass: "disagree-btn" }, [
                                    _c("i", { staticClass: "el-icon-close" })
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isReappraisal
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Αποδοχή πρότασης:" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Εισήγητη:" } },
                            [
                              !_vm.myJudgment.finalize
                                ? _c("el-switch", {
                                    attrs: {
                                      "active-text": "Ναι",
                                      "inactive-text": "Όχι"
                                    },
                                    model: {
                                      value: _vm.myJudgment.agreeWithProponent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.myJudgment,
                                          "agreeWithProponent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "myJudgment.agreeWithProponent"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.myJudgment.finalize &&
                              _vm.myJudgment.agreeWithProponent
                                ? _c("span", { staticClass: "agree-btn" }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.myJudgment.finalize &&
                              !_vm.myJudgment.agreeWithProponent
                                ? _c("span", { staticClass: "disagree-btn" }, [
                                    _c("i", { staticClass: "el-icon-close" })
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.fromConsultant ? _c("br") : _vm._e(),
                          _vm._v(" "),
                          _vm.fromConsultant
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Ακαδημαικoύ Συμβούλου:" } },
                                [
                                  !_vm.myJudgment.finalize
                                    ? _c("el-switch", {
                                        attrs: {
                                          "active-text": "Ναι",
                                          "inactive-text": "Όχι"
                                        },
                                        model: {
                                          value: _vm.myJudgment.agreeWithAC,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.myJudgment,
                                              "agreeWithAC",
                                              $$v
                                            )
                                          },
                                          expression: "myJudgment.agreeWithAC"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.myJudgment.finalize &&
                                  _vm.myJudgment.agreeWithAC
                                    ? _c("span", { staticClass: "agree-btn" }, [
                                        _c("i", {
                                          staticClass: "el-icon-check"
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.myJudgment.finalize &&
                                  !_vm.myJudgment.agreeWithAC
                                    ? _c(
                                        "span",
                                        { staticClass: "disagree-btn" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-close"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Εισήγηση:" } },
                    [
                      !_vm.myJudgment.finalize
                        ? _c("el-input", {
                            staticClass: "biggest",
                            attrs: {
                              type: "textarea",
                              placeholder:
                                "Η εισήγηση είναι υποχρεωτική σε περίπτωση διαφωνίας με τον Ειδικό Εισηγητή και/η με τον Ακαδημαϊκό Σύμβουλο καθώς και σε περίπτωση εμμονής/μερικής ικανοποίησης του αιτήματος επανεξέτασης",
                              autosize: { minRows: 3, maxRows: 10 }
                            },
                            on: { change: _vm.proposalChanged },
                            model: {
                              value: _vm.myJudgment.proposal,
                              callback: function($$v) {
                                _vm.$set(_vm.myJudgment, "proposal", $$v)
                              },
                              expression: "myJudgment.proposal"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.myJudgment.finalize
                        ? _c("span", [_vm._v(_vm._s(_vm.myJudgment.proposal))])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Εσωτερικό Σχόλιο:" } },
                    [
                      !_vm.myJudgment.finalize
                        ? _c("el-input", {
                            staticClass: "biggest",
                            attrs: {
                              placeholder:
                                "Εισάγετε προαιρετικά το σχόλιό σας για εσωτερική κατανάλωση",
                              type: "textarea",
                              autosize: { minRows: 3, maxRows: 10 }
                            },
                            model: {
                              value: _vm.myJudgment.comment,
                              callback: function($$v) {
                                _vm.$set(_vm.myJudgment, "comment", $$v)
                              },
                              expression: "myJudgment.comment"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.myJudgment.finalize
                        ? _c("span", [_vm._v(_vm._s(_vm.myJudgment.comment))])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "center" } },
                    [
                      !_vm.myJudgment.finalize
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                round: "",
                                icon: "el-icon-edit"
                              },
                              on: { click: _vm.tempSave }
                            },
                            [_vm._v("Προσωρινή Αποθήκευση\r\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.myJudgment.finalize
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "danger",
                                round: "",
                                icon: "el-icon-check",
                                disabled: _vm.canDisagree
                              },
                              on: { click: _vm.finalSave }
                            },
                            [_vm._v("Ολοκλήρωση\r\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isReappraisal &&
                      !_vm.myJudgment.finalize &&
                      !_vm.myJudgment.agreeWithProponent
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "warning",
                                icon: "el-icon-caret-left",
                                plain: "",
                                round: "",
                                disabled: _vm.canDisagree
                              },
                              on: { click: _vm.releaseApplication }
                            },
                            [_vm._v(" Επιστροφή στον Εισηγητή\r\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.myJudgment.finalize
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "large",
                                type: "danger",
                                round: ""
                              }
                            },
                            [
                              _vm._v(
                                "\r\n            Οριστικοποιημένη Εισήγηση\r\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("proposals"),
                  _vm._v(" "),
                  _c("internalComments")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68a29c0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a29c0e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/ExecutiveBoardMemberJudgement.vue
// module id = null
// module chunks = 